import Typography from '@mui/material/Typography';
import { Luggage, NoLuggage } from '@mui/icons-material';
import { PassengerLegBaggage } from '~/types';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

interface BookingExtrasWithPassengerDetailsProps {
  passengerLegBaggage: PassengerLegBaggage[];
  iconSize?: number;
  textSize?: number;
}



const BookingExtrasWithPassengerDetails = ({ passengerLegBaggage, iconSize = 16, textSize = 12 }: BookingExtrasWithPassengerDetailsProps) => {

  return (
    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
      {
        passengerLegBaggage.map((passenger, index) => {
          let baggageDetails;
          if (!passenger.chargeable && !passenger.included) {
            baggageDetails = (
              <Typography key={index} fontSize={textSize} display="inline-flex" alignItems="center">
                <NoLuggage sx={{ fontSize: iconSize }} style={{ marginRight: 2 }} />
                No check-in baggage
              </Typography>
            )

          }

          if (passenger.included && !passenger.chargeable) {
            baggageDetails = (
              <Typography key={index} fontSize={textSize} display="inline-flex" alignItems="center">
                <Luggage sx={{ fontSize: iconSize }} style={{ marginRight: 2 }} />
                {passenger.included} (included)
              </Typography>
            )
          }

          if (!passenger.included && passenger.chargeable) {
            baggageDetails = (
              <Typography key={index} fontSize={textSize} display="inline-flex" alignItems="center">
                <Luggage sx={{ fontSize: iconSize }} style={{ marginRight: 2 }} />
                {passenger.chargeable} (purchased)
              </Typography>
            )
          }

          if (passenger.included && passenger.chargeable) {
            baggageDetails = (
              <>
                <Typography key={index} fontSize={textSize} display="inline-flex" alignItems="center">
                  <Luggage sx={{ fontSize: iconSize }} style={{ marginRight: 2 }} />
                  {passenger.included} (included) {' '}
                  <Luggage sx={{ fontSize: iconSize }} style={{ marginRight: 2, marginLeft: 10 }} />{passenger.chargeable} (purchased)
                </Typography>
              </>

            )
          }

          return (
            <ListItem key={passenger.passengerId} style={{ margin: 0, padding: 0, paddingBottom: 2 }}>
              <ListItemText
                style={{ margin: 0 }}
                primary={`${passenger.fistName} ${passenger.lastName}`} secondary={baggageDetails}
              />
            </ListItem>
          )
        })
      }
    </List>
  );
};

export default BookingExtrasWithPassengerDetails;
